import API, { handleRequest } from "../lib/api";

export const getHolidays = (restaurant_id) =>
  handleRequest(() => API.get(`holidays?restaurant_id=${restaurant_id}`));

export const updateHolidays = (id, data) =>
  handleRequest(() => API.put(`holidays/${id}`, data));

export const createHolidays = (data) =>
  handleRequest(() => API.post(`holidays`, data));

export const deleteHolidays = (id) =>
  handleRequest(() => API.delete(`holidays/${id}`));
